<template>
  <div class="comments__layer">
    <div class="comments-title">
      <h1>专家评论</h1>
      <span @click="moreExpert">
        了解更多
        <i class="el-icon-arrow-right"></i>
      </span>
    </div>
    <div v-loading="loading" class="comments-list">
      <div class="comments-list-item" v-for="item in expertData" :key="item.id">
        <img class="comments-list-item-cover" :src="item.coverPhotoLink" alt="">
        <div class="comments-list-item-right">
          <div class="comments-list-item-right-title" @click="clickExpert(item.id)">
            {{ item.title }}
          </div>
          <div class="comments-list-item-right-content">
            <div class="comments-list-item-right-content-text">
              {{ item.synopsis }}
            </div>
            <div class="comments-list-item-right-content-time">
              {{ item.postTime.substring(0, 16) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { postCmsSystemRelay } from '@/apis/transfer'
export default {
  data() {
    return {
      expertData: [],
      // 接口参数
      loading: false,
      attrs: {
        type: "COMMANT",
        groupCode: "",
        pageIndex: 1,
        pageRow: 6,
      },
    }
  },
  created() {
    // 初始化数据
    this.init(this.attr, 0);
  },
  methods: {
    // 数据接口
    init(attr, key) {
      postCmsSystemRelay('hotNewsApi', this.attrs).then(res => {
      
        if (key == 1) {
          this.expertData = [...this.expertData, ...res.lst]
        } else {
          this.expertData = res.lst;
          this.loading = false;
        }
      }).catch(err => {
        console.log(err);
      })

    },
    // 获取更多评论 
    moreExpert() {
      this.$router.push('/Market?key=4')
      // if (this.attr.pageRow == 5) {
      //   this.attr.pageIndex = 1;
      //   this.attr.pageRow = 10;
      //   this.init(this.attr, 0);
      // } else {
      //   this.attr.pageIndex++;
      //   this.init(this.attr, 1);
      // }
    },
    // 跳转到评论详情页
    clickExpert(attr) {
      let routeData = this.$router.resolve({
        name: "expertDetails",
        query: {
          id: attr
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style lang="less" scoped>
.comments__layer {
  background: #FFFFFF;
  padding: 40px;

  .comments-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    h1 {
      margin: 0;
      font-size: 24px;
      color: #000;
    }

    span {
      font-size: 14px;
      color: #93939F;
      cursor: pointer;
    }
  }

  .comments-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 48%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 0;
      border-bottom: 1px solid #f1f1f1;

      &-cover {
        width: 200px;
        height: 88px;
        flex-shrink: 0;
        margin-right: 20px;
      }

      &-right {
        // flex: 1;
        width: 354px;

        &-title {
          font-weight: 700;
          color: #000;
          cursor: pointer;
          margin-bottom: 10px;
          white-space: nowrap;
          /* 禁止文本换行 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 超出部分显示省略号 */
        }

        &-content {
          display: flex;
          justify-content: space-between;
          align-items: end;
          font-size: 14px;
          color: #93939F;

          &-text {
            height: 44px;
            width: 58%;
            width: 212px;
            line-height: 22px;
            display: -webkit-box;
            /* 必须使用这个属性来支持多行省略号 */
            -webkit-box-orient: vertical;
            /* 必须设置为纵向排列 */
            -webkit-line-clamp: 2;
            /* 限制显示最多两行 */
            overflow: hidden;
            /* 超出部分隐藏 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
          }

          &-time {
            color: #93939F;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .comments__layer {
    padding: 40px 20px;

    .comments-title {
      h1 {
        font-size: 16px;
      }

      span {
        font-size: 12px;
      }
    }

    .comments-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      &-item {
        width: 100%;

        &-cover {
          width: 120px;
          height: 74px;
        }

        &-right {
          width: 187px;
          box-sizing: border-box;

          &-title {
            font-size: 16px;
            width: 187px;
          }

          &-content {
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: end;

            &-text {
              height: 17px;
              width: 187px;
              display: -webkit-box;
              /* 必须使用这个属性来支持多行省略号 */
              -webkit-box-orient: vertical;
              /* 必须设置为纵向排列 */
              -webkit-line-clamp: 1;
              /* 限制显示最多两行 */
              overflow: hidden;
              /* 超出部分隐藏 */
              text-overflow: ellipsis;
              /* 超出部分显示省略号 */
            }

            &-time {
              text-align: right;
              margin-top: 12px;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .comments__layer {
    background: #FFFFFF;
    padding: 40px;

    .comments-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      h1 {
        margin: 0;
        font-size: 24px;
        color: #000;
      }

      span {
        font-size: 14px;
        color: #93939F;
        cursor: pointer;
      }
    }

    .comments-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      &-item {
        width: 48%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 30px 0;
        border-bottom: 1px solid #f1f1f1;

        &-cover {
          width: 200px;
          height: 88px;
          flex-shrink: 0;
          margin-right: 20px;
        }

        &-right {
          // flex: 1;
          width: 224px;

          &-title {
            font-weight: 700;
            color: #000;
            cursor: pointer;
            margin-bottom: 10px;
            white-space: nowrap;
            /* 禁止文本换行 */
            overflow: hidden;
            /* 超出部分隐藏 */
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
          }

          &-content {
            display: flex;
            justify-content: space-between;
            align-items: end;
            font-size: 14px;
            color: #93939F;

            &-text {
              height: 44px;
              width: 58%;
              width: 108px;
              line-height: 22px;
              display: -webkit-box;
              /* 必须使用这个属性来支持多行省略号 */
              -webkit-box-orient: vertical;
              /* 必须设置为纵向排列 */
              -webkit-line-clamp: 2;
              /* 限制显示最多两行 */
              overflow: hidden;
              /* 超出部分隐藏 */
              text-overflow: ellipsis;
              /* 超出部分显示省略号 */
            }

            &-time {
              color: #93939F;
              font-size: 12px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
